<script>
  // Single entry point for rendering a collection of an entity. Looks up the entity
  // display config and dispatches to the table / grid / board view. A page writes
  // roughly:
  //
  //   <EntityList entity="users" rows={users} bind:viewMode onDelete={archive} />
  //
  // Columns, headers, badges, empty state and standard actions come from the
  // registry; links and the edit action read the row's server-built `*_url` keys
  // (`url`, `edit_url`). Pass an `actions` snippet to override the row actions.
  import { page } from '@inertiajs/svelte'
  import { entityFor } from '../../lib/entities/index.js'
  import EntityTable from './entity_table.svelte'
  import EntityGrid from './entity_grid.svelte'
  import EntityBoard from './entity_board.svelte'

  let {
    entity,
    rows = [],
    viewMode = null,
    density = 'full',
    loading = false,
    sort = null,
    onsort,
    onDelete = null,
    onToggle = null,
    onImageEdit = null,
    emptyMessage = null,
    actions,
    dragEnabled = false,
    onreorder,
    hiddenColumns = []
  } = $props()

  // Columns marked `areaScoped` (College Town) are redundant while the sidebar
  // area switcher already scopes the whole session to one town — drop them.
  // `hiddenColumns` (fields) is the server's call on columns this admin may not see.
  const areaSelected = $derived(!!$page?.props?.current_area_id)
  const config = $derived.by(() => {
    const base = entityFor(entity)
    const columns = base.columns.filter((c) => !(areaSelected && c.areaScoped) && !hiddenColumns.includes(c.field))
    return { ...base, columns }
  })
  const mode = $derived(viewMode ?? config.defaultView ?? 'table')
</script>

{#if mode === 'grid' && config.grid}
  <EntityGrid {config} {rows} {onDelete} {onToggle} {emptyMessage} {actions} />
{:else if mode === 'board' && config.board}
  <EntityBoard {config} {rows} />
{:else}
  <EntityTable
    {config}
    {rows}
    {density}
    {loading}
    {sort}
    {onsort}
    {onDelete}
    {onToggle}
    {onImageEdit}
    {emptyMessage}
    {actions}
    {dragEnabled}
    {onreorder}
  />
{/if}
